<app-loader *ngIf="loading"></app-loader>
<div class="min-h-screen flex flex-col items-center justify-center bg-header_bg px-2 xs:px-4">
  <div class="w-full max-w-[260px] xs:max-w-md bg-white rounded-2xl shadow-xl px-6 py-8 text-center">
    
    <div class="flex justify-center mb-4 xs:mb-6">
      <!-- <div class="relative">
        <div class="w-12 h-12 xs:w-8 xs:h-8 border-4 border-blue-100 rounded-full"></div>
        <div class="absolute top-0 left-0 w-12 h-12 xs:w-8 xs:h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div> -->
    </div>

    <h2 class="text-lg xs:text-2xl text-primary_Text_Color  mb-2 poppinsRegular tracking-wider leading-tight">
      Redirecting you...
    </h2>
    <p class="text-sm xs:text-base text-gray-500 mb-6 poppinsRegular tracking-wider">
      Please wait a moment while we take you to the dashboard.
    </p>

    <div class="w-full bg-gray-100 rounded-full h-1.5 overflow-hidden">
      <div class="bg-primary_Bg_Button_Color h-full animate-progress-ind"></div>
    </div>

  </div>
</div>